import React from "react";
import style from "./UnableToAssessWound.module.scss";
import { useUnableToAssessWound } from "./hooks/useUnableToAssessWound";
import { Modal } from "../../../secondary";
import { getPatientRefusalReason } from "../../../../utils";
import constants from "../../../../constants/constants.json";

const SuccessState = ({ activeChip }) => (
  <div className={style.success_state}>
    <div className={style.success_icon}>
      <i className="fa fa-check-circle" aria-hidden="true" />
    </div>
    <p className={style.success_text}>{getPatientRefusalReason(activeChip)} Documented</p>
  </div>
);

const EmptyReasonsState = () => (
  <div className={style.empty_state}>
    <div className={style.empty_icon}>
      <i className="fa fa-info-circle" aria-hidden="true" />
    </div>
    <p className={style.empty_text}>{constants.patient.unableToAssessWoundNoReasons}</p>
  </div>
);

const ReasonCard = ({ item, index, isActive, onSelect }) => (
  <button
    type="button"
    className={`${style.card} ${isActive ? style.card_active : ""}`}
    onClick={onSelect}
    aria-pressed={isActive}
    style={{ animationDelay: `${index * 60}ms` }}
  >
    <div className={style.card_icon}>{item.icon}</div>
    <div className={style.card_body}>
      <span className={style.card_name}>{item.value}</span>
      <span className={style.card_desc}>{item.desc}</span>
    </div>
    <div className={style.card_check}>
      <i className="fa fa-check" aria-hidden="true" />
    </div>
  </button>
);

const NotesField = ({ notes, activeChip, onChange }) => (
  <div className={style.notes_wrap}>
    <label className={style.notes_label} htmlFor="unable-assess-notes">
      Notes <span className={style.notes_optional}>{activeChip === "other" ? <><span className={style.required}>*</span> (Please enter your reasoning for the other)</> : "(Optional)"}</span>
    </label>
    <textarea
      id="unable-assess-notes"
      className={style.notes_textarea}
      value={notes}
      onChange={onChange}
      placeholder="Add notes here..."
      rows={3}
    />
  </div>
);

const ReasonSelector = ({ selectedReasons, activeChip, notes, onSelect, onNoteChange }) => (
  <div>
    <div className={style.grid}>
      {selectedReasons.map((item, index) => (
        <ReasonCard key={item.key} item={item} index={index} isActive={activeChip === item.key} onSelect={() => onSelect(item.key)} />
      ))}
    </div>
    <NotesField notes={notes} activeChip={activeChip} onChange={onNoteChange} />
  </div>
);

const UnableToAssessWound = ({ onClose }) => {
  const { activeChip, notes, isSuccess, isLoading, isDisabled, selectedReasons, handleNoteChange, handleSelect, handleConfirm } = useUnableToAssessWound();
  const hasReasons = !!selectedReasons?.length;

  return (
    <Modal modalOpen={true} modalSize={style.custom_modal_size}>
      <div className={style.container}>
        <div className={style.header}>
          <h2 className={style.title}>{isSuccess ? "Unable to assess wound" : "Select why you are unable to assess wound"}</h2>
          <button type="button" className={style.close_btn} onClick={onClose} aria-label="Close modal">
            &times;
          </button>
        </div>

        {isSuccess && <SuccessState activeChip={activeChip} />}
        {!isSuccess && !hasReasons && <EmptyReasonsState />}
        {!isSuccess && hasReasons && (
          <ReasonSelector selectedReasons={selectedReasons} activeChip={activeChip} notes={notes} onSelect={handleSelect} onNoteChange={handleNoteChange} />
        )}

        <div className={style.footer}>
          <div className={style.footer_actions}>
            {isSuccess && (
              <button type="button" className={style.btn_secondary} onClick={onClose} aria-label="Close">
                <span>Close</span>
              </button>
            )}
            {!isSuccess && hasReasons && (
              <button
                type="button"
                className={`${style.btn_primary} ${isDisabled ? style.btn_disabled : ""}`}
                onClick={handleConfirm}
                disabled={isDisabled || isLoading}
              >
                {isLoading && <div className={style.spinner}></div>}
                <span>Save</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default UnableToAssessWound;
